import Api from "./api";
import {
    QuotationParams,
    SaveQuotationValues,
} from "../containers/quotation/types/quotation";
import { COD_APPLICATION, TEMPLATE_TYPE } from "../constants/payroll-file";
import { TypeRates } from "../constants/enums/quotation";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";

type PreQuotation = {
    agePolicyAgreement: boolean;
    companySize: string;
    contactFullName: string;
    documentId: string;
    documentType: string;
    email: string;
    mobile: string;
    privacyPolicyAgreement: boolean;
    totalPayrollAmount: number;
    workerOutOfSalaryRange: boolean;
};

export class QuotationApi {
    static URL =
        "ne-registra-precotizaciones-vida-ley-empleados-vda/precotizacion/v1";

    static savePreQuotation = (
        preQuotation: PreQuotation
    ): Observable<{ id: string }> =>
        Api.post(`${QuotationApi.URL}/save`, {
            entity: preQuotation,
            customHeader: {
                ...Api.getPrivateHeader(),
                Accept: "*/*",
                "Content-Type": "application/json",
            },
        }).pipe(map((resp) => resp.response));

    static getPreQuotationValues = (quotation: QuotationParams) => {
        const url =
            "ne-calcula-precotizaciones-vida-ley-empleados-vda/precotizacion/v1";
        return Api.post(`${url}/calculate`, {
            entity: quotation,
        });
    };

    static calculateQuotation = ({
        fileName,
        typeRate,
    }: {
        fileName: string;
        typeRate: TypeRates;
    }) =>
        Api.post(
            `ms-ne-calcula-cotizaciones-vida-ley-empleados-vda/cotizacion/vida-ley-empleados/v1/calcular`,
            {
                entity: {
                    template: {
                        key: fileName,
                        location: "LIMA",
                        packageAmount: 0,
                        rma: true,
                        type: TEMPLATE_TYPE,
                        typeDocument: "RUC",
                        codigoaplicacion: COD_APPLICATION,
                        typeRate,
                    },
                },
            }
        );

    static saveQuotation = (body: SaveQuotationValues) =>
        Api.post(
            "ms-registra-cotizaciones-vida-ley-empleados-vda/cotizacion/v1/save",
            {
                entity: body,
            }
        );
}
